var map = {
	"./form/index.js": 1214,
	"./info/index.js": 1218
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2749;


//////////////////
// WEBPACK FOOTER
// ./src/components/app/registration/optional-groups \.\/[^\/]+\/index\.jsx?$
// module id = 2749
// module chunks = 0